import { Component, ComponentFactory, Input, OnInit, ViewChild } from "@angular/core";
import { CardDirective } from "@app/home/card/card.directive";
import { User } from "@app/shared/user";

@Component({
  selector: "om-card",
  templateUrl: "./card.component.html",
  styleUrls: [],
})
export class CardComponent implements OnInit {
  @Input() card: ComponentFactory<any>;
  @Input() user: User;
  @ViewChild(CardDirective) cardDirective: CardDirective;

  constructor() {}

  ngOnInit() {
    const viewContainerRef = this.cardDirective.viewContainerRef;
    viewContainerRef.clear();
    let componentRef = viewContainerRef.createComponent(this.card);
    componentRef.instance.user = this.user;
  }
}
